export const button = {
  root: {
    borderRadius: "{form.field.border.radius}",
    roundedBorderRadius: "2rem",
    gap: "{gap.6}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    iconOnlyWidth: "{form.field.icon.size}",
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}",
      iconOnlyWidth: "26px",
    },
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}",
      iconOnlyWidth: "auto",
    },
    label: {
      fontWeight: "600",
    },
    raisedShadow: "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      offset: "{focus.ring.offset}",
    },
    badgeSize: "1rem",
    transitionDuration: "{form.field.transition.duration}",
  },
  colorScheme: {
    light: {
      root: {
        primary: {
          background: "{primary.default}",
          hoverBackground: "{primary.hover}",
          activeBackground: "{primary.active}",
          borderColor: "{primary.default}",
          hoverBorderColor: "{primary.hover}",
          activeBorderColor: "{primary.active}",
          color: "{color.white}",
          hoverColor: "{color.white}",
          activeColor: "{color.white}",
          focusRing: {
            color: "{primary.default}",
            shadow: "none",
          },
        },
        secondary: {
          background: "{surface.bg-white}",
          hoverBackground: "{surface.bg-grey}",
          activeBackground: "{surface.bg-grey-contrast}",
          borderColor: "{surface.border.secondary}",
          hoverBorderColor: "{surface.border}",
          activeBorderColor: "{surface.border}",
          color: "{text.body}",
          hoverColor: "{text.body}",
          activeColor: "{text.body}",
          focusRing: {
            color: "{surface.bg-grey}",
            shadow: "none",
          },
        },
        info: {
          background: "{info.default}",
          hoverBackground: "{color.blue.800}",
          activeBackground: "{color.blue.900}",
          borderColor: "{info.default}",
          hoverBorderColor: "{color.blue.800}",
          activeBorderColor: "{color.blue.900}",
          color: "{color.white}",
          hoverColor: "{color.white}",
          activeColor: "{color.white}",
          focusRing: {
            color: "{info.default}",
            shadow: "none",
          },
        },
        success: {
          background: "{success.default}",
          hoverBackground: "{color.green.800}",
          activeBackground: "{color.green.900}",
          borderColor: "{success.default}",
          hoverBorderColor: "{color.green.800}",
          activeBorderColor: "{color.green.900}",
          color: "{color.white}",
          hoverColor: "{color.white}",
          activeColor: "{color.white}",
          focusRing: {
            color: "{success.default}",
            shadow: "none",
          },
        },
        warn: {
          background: "{warning-soft.default}",
          hoverBackground: "{color.yellow.800}",
          activeBackground: "{color.yellow.900}",
          borderColor: "{warning-soft.default}",
          hoverBorderColor: "{color.yellow.800}",
          activeBorderColor: "{color.yellow.900}",
          color: "{color.white}",
          hoverColor: "{color.white}",
          activeColor: "{color.white}",
          focusRing: {
            color: "{warning-soft.default}",
            shadow: "none",
          },
        },
        // help: {
        //   background: "{purple.500}",
        //   hoverBackground: "{purple.600}",
        //   activeBackground: "{purple.700}",
        //   borderColor: "{purple.500}",
        //   hoverBorderColor: "{purple.600}",
        //   activeBorderColor: "{purple.700}",
        //   color: "#ffffff",
        //   hoverColor: "#ffffff",
        //   activeColor: "#ffffff",
        //   focusRing: {
        //     color: "{purple.500}",
        //     shadow: "none",
        //   },
        // },
        danger: {
          background: "{danger.default}",
          hoverBackground: "{color.red.700}",
          activeBackground: "{color.red.800}",
          borderColor: "{danger.default}",
          hoverBorderColor: "{color.red.700}",
          activeBorderColor: "{color.red.800}",
          color: "{color.white}",
          hoverColor: "{color.white}",
          activeColor: "{color.white}",
          focusRing: {
            color: "{danger.default}",
            shadow: "none",
          },
        },
        // contrast: {
        //   background: "{surface.950}",
        //   hoverBackground: "{surface.900}",
        //   activeBackground: "{surface.800}",
        //   borderColor: "{surface.950}",
        //   hoverBorderColor: "{surface.900}",
        //   activeBorderColor: "{surface.800}",
        //   color: "{surface.0}",
        //   hoverColor: "{surface.0}",
        //   activeColor: "{surface.0}",
        //   focusRing: {
        //     color: "{surface.950}",
        //     shadow: "none",
        //   },
        // },
      },
      outlined: {
        primary: {
          hoverBackground: "{primary.background}",
          activeBackground: "{primary.background}",
          borderColor: "{primary.default}",
          color: "{primary.default}",
        },
        secondary: {
          hoverBackground: "{surface.bg-grey}",
          activeBackground: "{surface.bg-grey-contrast}",
          borderColor: "{surface.border}",
          color: "{text.body}",
        },
        success: {
          hoverBackground: "{success.support}",
          activeBackground: "{success.support}",
          borderColor: "{success.default}",
          color: "{success.default}",
        },
        info: {
          hoverBackground: "{info.support}",
          activeBackground: "{info.support}",
          borderColor: "{info.default}",
          color: "{info.default}",
        },
        warn: {
          hoverBackground: "{warning.support}",
          activeBackground: "{warning.support}",
          borderColor: "{warning.default}",
          color: "{warning.default}",
        },
        // help: {
        //   hoverBackground: "{purple.50}",
        //   activeBackground: "{purple.100}",
        //   borderColor: "{purple.200}",
        //   color: "{purple.500}",
        // },
        danger: {
          hoverBackground: "{danger.support}",
          activeBackground: "{danger.support}",
          borderColor: "{danger.default}",
          color: "{danger.default}",
        },
        // contrast: {
        //   hoverBackground: "{surface.50}",
        //   activeBackground: "{surface.100}",
        //   borderColor: "{surface.700}",
        //   color: "{surface.950}",
        // },
        // plain: {
        //   hoverBackground: "{surface.50}",
        //   activeBackground: "{surface.100}",
        //   borderColor: "{surface.200}",
        //   color: "{surface.700}",
        // },
      },
      text: {
        primary: {
          // hoverBackground: "{primary.50}",
          // activeBackground: "{primary.100}",
          color: "{primary.default}",
        },
        secondary: {
          // hoverBackground: "{surface.50}",
          // activeBackground: "{surface.100}",
          color: "{text.body}",
        },
        success: {
          // hoverBackground: "{green.50}",
          // activeBackground: "{green.100}",
          color: "{success.default}",
        },
        info: {
          // hoverBackground: "{sky.50}",
          // activeBackground: "{sky.100}",
          color: "{info.default}",
        },
        warn: {
          // hoverBackground: "{orange.50}",
          // activeBackground: "{orange.100}",
          color: "{warning.default}",
        },
        // help: {
        //   hoverBackground: "{purple.50}",
        //   activeBackground: "{purple.100}",
        //   color: "{purple.500}",
        // },
        danger: {
          // hoverBackground: "{red.50}",
          // activeBackground: "{red.100}",
          color: "{danger.default}",
        },
        // contrast: {
        //   hoverBackground: "{surface.50}",
        //   activeBackground: "{surface.100}",
        //   color: "{surface.950}",
        // },
        // plain: {
        //   hoverBackground: "{surface.50}",
        //   activeBackground: "{surface.100}",
        //   color: "{surface.700}",
        // },
      },
      link: {
        color: "{primary.support}",
        hoverColor: "{primary.default}",
        activeColor: "{primary.default}",
      },
    },
    dark: {
      root: {
        primary: {
          background: "{primary.support}",
          hoverBackground: "{primary.hover}",
          activeBackground: "{primary.active}",
          borderColor: "{primary.support}",
          hoverBorderColor: "{primary.hover}",
          activeBorderColor: "{primary.active}",
          color: "{color.white}",
          hoverColor: "{color.white}",
          activeColor: "{color.white}",
          focusRing: {
            color: "{primary.support}",
            shadow: "none",
          },
        },
        secondary: {
          background: "{surface.bg-white}",
          hoverBackground: "{surface.bg-grey}",
          activeBackground: "{surface.bg-grey-contrast}",
          borderColor: "{surface.border}",
          hoverBorderColor: "{surface.border}",
          activeBorderColor: "{surface.border}",
          color: "{text.body}",
          hoverColor: "{text.body}",
          activeColor: "{text.body}",
          focusRing: {
            color: "{surface.bg-grey}",
            shadow: "none",
          },
        },
        info: {
          background: "{info.support}",
          hoverBackground: "{color.blue.800}",
          activeBackground: "{color.blue.900}",
          borderColor: "{info.support}",
          hoverBorderColor: "{color.blue.800}",
          activeBorderColor: "{color.blue.900}",
          color: "{color.white}",
          hoverColor: "{color.white}",
          activeColor: "{color.white}",
          focusRing: {
            color: "{info.support}",
            shadow: "none",
          },
        },
        success: {
          background: "{success.support}",
          hoverBackground: "{color.green.800}",
          activeBackground: "{color.green.900}",
          borderColor: "{success.support}",
          hoverBorderColor: "{color.green.800}",
          activeBorderColor: "{color.green.900}",
          color: "{color.white}",
          hoverColor: "{color.white}",
          activeColor: "{color.white}",
          focusRing: {
            color: "{success.support}",
            shadow: "none",
          },
        },
        warn: {
          background: "{warning-soft.support}",
          hoverBackground: "{color.yellow.800}",
          activeBackground: "{color.yellow.900}",
          borderColor: "{warning-soft.support}",
          hoverBorderColor: "{color.yellow.800}",
          activeBorderColor: "{color.yellow.900}",
          color: "{color.white}",
          hoverColor: "{color.white}",
          activeColor: "{color.white}",
          focusRing: {
            color: "{warning-soft.support}",
            shadow: "none",
          },
        },
        // help: {
        //   background: "{purple.500}",
        //   hoverBackground: "{purple.600}",
        //   activeBackground: "{purple.700}",
        //   borderColor: "{purple.500}",
        //   hoverBorderColor: "{purple.600}",
        //   activeBorderColor: "{purple.700}",
        //   color: "#ffffff",
        //   hoverColor: "#ffffff",
        //   activeColor: "#ffffff",
        //   focusRing: {
        //     color: "{purple.500}",
        //     shadow: "none",
        //   },
        // },
        danger: {
          background: "{danger.support}",
          hoverBackground: "{color.red.700}",
          activeBackground: "{color.red.800}",
          borderColor: "{danger.support}",
          hoverBorderColor: "{color.red.700}",
          activeBorderColor: "{color.red.800}",
          color: "{color.white}",
          hoverColor: "{color.white}",
          activeColor: "{color.white}",
          focusRing: {
            color: "{danger.support}",
            shadow: "none",
          },
        },
        // contrast: {
        //   background: "{surface.950}",
        //   hoverBackground: "{surface.900}",
        //   activeBackground: "{surface.800}",
        //   borderColor: "{surface.950}",
        //   hoverBorderColor: "{surface.900}",
        //   activeBorderColor: "{surface.800}",
        //   color: "{surface.0}",
        //   hoverColor: "{surface.0}",
        //   activeColor: "{surface.0}",
        //   focusRing: {
        //     color: "{surface.950}",
        //     shadow: "none",
        //   },
        // },
      },
      outlined: {
        primary: {
          hoverBackground: "{primary.default}",
          activeBackground: "{primary.default}",
          borderColor: "{primary.support}",
          color: "{primary.support}",
        },
        secondary: {
          hoverBackground: "{surface.bg-grey}",
          activeBackground: "{surface.bg-grey-contrast}",
          borderColor: "{surface.border}",
          color: "{text.body}",
        },
        success: {
          hoverBackground: "{success.default}",
          activeBackground: "{success.default}",
          borderColor: "{success.support}",
          color: "{success.support}",
        },
        info: {
          hoverBackground: "{info.default}",
          activeBackground: "{info.default}",
          borderColor: "{info.support}",
          color: "{info.support}",
        },
        warn: {
          hoverBackground: "{warning.default}",
          activeBackground: "{warning.default}",
          borderColor: "{warning.support}",
          color: "{warning.support}",
        },
        // help: {
        //   hoverBackground: "{purple.50}",
        //   activeBackground: "{purple.100}",
        //   borderColor: "{purple.200}",
        //   color: "{purple.500}",
        // },
        danger: {
          hoverBackground: "{danger.default}",
          activeBackground: "{danger.default}",
          borderColor: "{danger.support}",
          color: "{danger.support}",
        },
        // contrast: {
        //   hoverBackground: "{surface.50}",
        //   activeBackground: "{surface.100}",
        //   borderColor: "{surface.700}",
        //   color: "{surface.950}",
        // },
        // plain: {
        //   hoverBackground: "{surface.50}",
        //   activeBackground: "{surface.100}",
        //   borderColor: "{surface.200}",
        //   color: "{surface.700}",
        // },
      },
      text: {
        primary: {
          // hoverBackground: "{primary.50}",
          // activeBackground: "{primary.100}",
          color: "{primary.support}",
        },
        secondary: {
          // hoverBackground: "{surface.50}",
          // activeBackground: "{surface.100}",
          color: "{text.body}",
        },
        success: {
          // hoverBackground: "{green.50}",
          // activeBackground: "{green.100}",
          color: "{success.support}",
        },
        info: {
          // hoverBackground: "{sky.50}",
          // activeBackground: "{sky.100}",
          color: "{info.support}",
        },
        warn: {
          // hoverBackground: "{orange.50}",
          // activeBackground: "{orange.100}",
          color: "{warning.support}",
        },
        // help: {
        //   hoverBackground: "{purple.50}",
        //   activeBackground: "{purple.100}",
        //   color: "{purple.500}",
        // },
        danger: {
          // hoverBackground: "{red.50}",
          // activeBackground: "{red.100}",
          color: "{danger.support}",
        },
        // contrast: {
        //   hoverBackground: "{surface.50}",
        //   activeBackground: "{surface.100}",
        //   color: "{surface.950}",
        // },
        // plain: {
        //   hoverBackground: "{surface.50}",
        //   activeBackground: "{surface.100}",
        //   color: "{surface.700}",
        // },
      },
      link: {
        color: "{primary.support}",
        hoverColor: "{primary.default}",
        activeColor: "{primary.default}",
      },
    },
  },
  extend: {
    ui: {
      fontLeading: "{form.field.font.leading}",
      secondary: {
        iconColor: "{color.gray.400}",
      },
      label: {
        link: {
          fontWeight: "500",
        },
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-button {
      line-height: ${dt("button.ui.font.leading")};
    }

    .p-button-secondary .p-button-icon {
      color: ${dt("button.ui.secondary.icon.color")};
    }

    .p-button-link .p-button-label {
      font-weight: ${dt("button.ui.label.link.font.weight")};
    }

    .p-button-link:not(:disabled):hover .p-button-label {
      text-decoration: unset;
    }
  `,
};
